import { render, staticRenderFns } from "./FormattedNumber.vue?vue&type=template&id=1057152a&"
import script from "./FormattedNumber.vue?vue&type=script&lang=js&"
export * from "./FormattedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports